module.exports = __webpack_public_path__ + "media/application_histories/icon_paper_airplane_hover-427dc3f3.svg";